// extracted by mini-css-extract-plugin
export default {"layout":"main_layout__OZfYZ","sidebar":"main_sidebar__IAfc+","wrapper":"main_wrapper__iWGz8"};